export default __webpack_public_path__ + "ab2039d854ef75dfc09afcf571fae7aa.png";